 <section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      <ng-container *ngIf="docTitle; else docNumTitle">{{ docTitle }}</ng-container>
      <ng-template #docNumTitle>
        {{ "translate.reports.document" | translate }} {{ docNum }}
      </ng-template>
    </h2>
    &nbsp;
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section> 

<div class="preview-container">
  <div class="file-preview">
    <iframe [src]="getPdfUrl()"></iframe>
  </div>
</div>
